import React, {useState} from 'react'
import axios from '../../api/axios';
import Image from '../../shared/image/Image';
import "./Login.css"
import ValidationMessage from '../../shared/validationmessage/ValidationMessage';
import ErrorMessages from '../../shared/errormessages/ErrorMessages';

const Login = (props) => {
  /* data handling */
  const [UserName, setUserName] = useState();
  const [Password, setPassword] = useState();

  /* exceoption handling */
  const [errors, setErrors] = useState("");
  const [validations, setValidations] = useState({
    UserName: [],
    Password: []
  });

  const resetValidations=()=>{
    setValidations({
      UserName: [],
      Password: []
    });
    setErrors("");
  }

  const parseErrorResponse=(response)=>{
    if(response.data.errors){
      setErrors("");
      setValidations(response.data.errors);
    }
  }

  const handleSubmit = async e =>{
    e.preventDefault();

    axios.post('/account/login', {
      UserName: UserName,
      Password: Password
    })
    .then(function (response) {
        resetValidations();

        if(response.data.status == "success"){

          localStorage.setItem("username", response.data.userName);
          localStorage.setItem("userrole", response.data.userRole);
          localStorage.setItem("userphoto", response.data.photo);
          localStorage.setItem("timestamp", response.data.timestamp);
  
          localStorage.setItem("usercompany", response.data.company.id);
          localStorage.setItem("usercompanylogo", response.data.company.logo);
          localStorage.setItem("usercompanyname", response.data.company.name);
          localStorage.setItem("canmanagesituations", response.data.company.situations);
  
          localStorage.setItem("token", response.data.token);
          props.setToken(response.data.token);
        }
        else{
          setErrors(response.data.message);
        }
    })
    .catch(function (error) {
      parseErrorResponse(error.response);
    });
  }
    
  return (
    <div className="login-wrapper">
    <div className="login-view">
      <form onSubmit={handleSubmit}>
      <Image className="logo" title="InspireOne" src="images/Logo.png"/>
      <div className="mb-2">
        <label htmlFor="email" className="form-label req">Email</label>
        <input type="text" id="email" className="form-control" autoFocus={true} onChange={e=> setUserName(e.target.value)} />
        <ValidationMessage field="UserName" errors={validations} />
      </div>
      <div className="mb-3">
        <label htmlFor="Password" className="form-label req">Password</label>
        <input type="Password" id="Password" className="form-control" onChange={e=> setPassword(e.target.value)} />
        <ValidationMessage field="Password" errors={validations} />
      </div>
      <div className="mb-1">
      <ErrorMessages message={errors}/>
      <button type="submit" className="btn btn-primary">Login</button>
      </div>
    </form>
    </div>
    </div>
  )
}

export default Login